<template>
  <div>
    <canvas ref="chartCanvas" :style="{ width: '100%', height: '150px' }"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'; // Import Chart.js

export default {
  name: 'InsightMSBarChart',
  props: {
    chartData: Object, // Chart data passed from parent
  },
  data() {
    return {
      chartInstance: null, // Store the Chart.js instance
    };
  },
  methods: {
    createChart() {
      // Destroy the existing chart instance if it exists
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      // Get the canvas element
      const ctx = this.$refs.chartCanvas.getContext('2d');

      // Transform the chartData into a format that Chart.js understands
      const labels = this.chartData.ticks.map(tick => tick[1]); // Extract labels from ticks
      const datasets = this.chartData.data.map((series, index) => ({
        label: series.label || `Series ${index + 1}`, // Use series label or default
        data: series.data.map(point => point[1]), // Extract Y values
        backgroundColor: this.getSeriesColor(index), // Assign colors
        borderWidth: 0, // No border
      }));

      // Create a new Chart.js instance
      this.chartInstance = new Chart(ctx, {
        type: 'bar', // Use a bar chart
        data: {
          labels: labels, // X-axis labels
          datasets: datasets, // Y-axis datasets
        },
        options: {
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Allow custom height/width
          legend: {
            display: true, // Show the legend
            position: 'bottom', // Position the legend at the bottom
            labels: {
              fontColor: '#333', // Legend label color
              boxWidth: 12, // Size of the legend color box
              padding: 10, // Padding between legend items
            },
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontColor: '#333', // X-axis label color
                },
                gridLines: {
                  display: false, // Hide grid lines for X-axis
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true, // Start Y-axis from 0
                  fontColor: '#333', // Y-axis label color
                },
                gridLines: {
                  color: '#eee', // Light grid lines for Y-axis
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Calls vs Scheduled', // Y-axis label
                  fontColor: '#333',
                  fontSize: 14,
                },
              },
            ],
          },
          tooltips: {
            enabled: true, // Enable tooltips
            mode: 'index', // Show tooltips for all datasets at the same index
            intersect: false, // Allow hovering over multiple bars
            callbacks: {
              label: (tooltipItem, data) => {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = tooltipItem.yLabel;
                return `${datasetLabel}: ${value}`;
              },
            },
          },
        },
      });
    },
    getSeriesColor(index) {
      // Teamio Huddle-style color palette - consistent across all charts
      const colors = [
        '#3abf94',  // Primary green (brand)
        '#3b82f6',  // Blue
        '#8b5cf6',  // Purple
        '#f59e0b',  // Amber
        '#64748b',  // Slate
        '#06b6d4',  // Cyan
        '#ec4899',  // Pink
        '#10b981',  // Emerald
        '#6366f1',  // Indigo
        '#78716c',  // Stone
      ];
      return colors[index % colors.length]; // Cycle through colors
    },
  },
  mounted() {
    // Create the chart when the component is mounted
    if (this.chartData) {
      this.createChart();
    }
  },
  watch: {
    // Watch for changes in chartData and update the chart
    chartData(newData) {
      if (newData) {
        this.createChart();
      }
    },
  },
  beforeDestroy() {
    // Destroy the chart instance when the component is destroyed
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>